// src/pages/Categories.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Categories.css";
import HeaderThree from "./HeaderThree";
import FooterOne from "../footer/FooterOne";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        "https://nazarenterprise.com/nazar-admin/api/get_products_category.php"
      )
      .then((res) => {
        const parents = res.data.data.filter(
          (cat) => cat.parent_category_id === 0
        );
        setCategories(parents);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="categories-loading">
        <div className="spinner"></div>
        <p>Loading marine categories...</p>
      </div>
    );
  }

  return (
    <>
    <HeaderThree />
      <div className="categories-page">
        <div className="categories-header">
          <h1>Our Product Categories</h1>
          <p>Premium Ship Machinery & Marine Equipment Solutions</p>
          <div className="header-underline"></div>
        </div>

        <div className="categories-grid">
          {categories.map((cat) => {
            const imgUrl = cat.category_image
              ? `https://nazarenterprise.com/nazar-admin/uploads/categories/${cat.category_image}`
              : null;

            return (
              <Link
                key={cat.id}
                to={`/products/${cat.id}`}
                className="category-card"
              >
                <div className="category-image-container">
                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={cat.category_name}
                      className="category-image"
                    />
                  ) : (
                    <div className="category-placeholder">
                      <span>{cat.category_name}</span>
                    </div>
                  )}
                  <div className="category-overlay">
                    <h3>{cat.category_name}</h3>
                    <p>View All Products</p>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="categories-footer">
          <div className="footer-content">
            <h3>Looking for Something Specific?</h3>
            <p>
              We specialize in custom marine solutions. Our experts are ready to
              help.
            </p>
            <Link to="/contact" className="cta-button">
              Get Expert Consultation
            </Link>
          </div>
        </div>
      </div>
      <FooterOne />
    </>
  );
};

export default Categories;
